import { DatabaseOperationEnum } from '../../../enums/database-operation.enum';
import { AppSubjectEnum } from '../../../modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../modules/base/dtos/base.dto';

/**
 * Audit log DTO for records
 */
@CaslSubject(AppSubjectEnum.AUDIT_LOG)
export class AuditLogRecordDto extends BaseDto {
	userId!: number;
	subject!: AppSubjectEnum;
	subjectId!: number;
	subjectOwnedByUserId!: number;
	operation!: DatabaseOperationEnum;
	payload?: Record<string, any>;
}
